import React, { useState } from 'react';
import PropTypes from 'prop-types';
import ReactI18n from 'react-i18n';
import {
  CallToActionButton,
  IconFontAwesome,
  TextCaption
} from '@directsoftware/ui-kit-web-admin';
import downloadReceiptPdf from '../../../utils/download-receipt-pdf';

const t = key => ReactI18n.getIntlMessage(`cx.receipt.redesign.${key}`);

const DownloadPdfButton = ({ brand, bookingCode }) => {
  const [downloading, setDownloading] = useState(false);
  const [failed, setFailed] = useState(false);

  const handleDownload = async () => {
    setDownloading(true);
    setFailed(false);
    try {
      await downloadReceiptPdf(brand, bookingCode);
    } catch {
      setFailed(true);
    } finally {
      setDownloading(false);
    }
  };

  return (
    <div>
      <CallToActionButton
        appearance="outline"
        variation="secondary"
        prependIcon={
          downloading ? (
            <IconFontAwesome name="spinner" spin />
          ) : (
            <IconFontAwesome name="download" iconStyle="regular" />
          )
        }
        isFullWidth
        isDisabled={downloading}
        onClick={handleDownload}
      >
        {t('download_pdf')}
      </CallToActionButton>
      {failed && (
        <TextCaption role="alert" isFullWidth>
          {t('download_pdf_error')}
        </TextCaption>
      )}
    </div>
  );
};

DownloadPdfButton.propTypes = {
  brand: PropTypes.object.isRequired,
  bookingCode: PropTypes.string.isRequired
};

export default DownloadPdfButton;
